import axios from 'axios';

// API para serviços SPED (Reforma Tributária)
const API_SPED_URL = process.env.REACT_APP_API_SPED || 'https://api.vidal-app.com';

const apiSped = axios.create({
  baseURL: API_SPED_URL,
  timeout: 60000, // Timeout maior para consultas pesadas do Elasticsearch
  headers: {
    'Content-Type': 'application/json'
  }
});

apiSped.interceptors.request.use(
  (config) => {
    // Modo demo: simula mutações
    const isDemo = (() => { try { return localStorage.getItem('vidal_demo_mode') === 'true'; } catch { return false; } })();
    const method = (config.method || 'get').toLowerCase();
    const isReadPost = /(search|count|stats|kpis|aggregat|export|relatorio|report)/i.test(config.url || '');
    if (isDemo && !['get', 'head'].includes(method) && !isReadPost) {
      config.adapter = () => Promise.resolve({
        data: { success: true, simulated: true, demo: true },
        status: 200, statusText: 'OK (demo)', headers: {}, config,
      });
    }

    const authData = JSON.parse(localStorage.getItem('vidal_auth') || '{}');
    const token = authData.token;
    const projeto = localStorage.getItem('vidal_selected_project');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (projeto && !config.headers.projeto) {
      config.headers.projeto = projeto;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiSped.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('vidal_auth');
      localStorage.removeItem('vidal_user');
      localStorage.removeItem('vidal_selected_project');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default apiSped;
